import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useRoutes } from "react-router-dom";
import { AppRoutes } from "./appRoutes";
import { EnvironmentSettings } from "./assets/configuration/environmentSettings";
import { Layout, onLogin, onLogout } from "./assets/layouts";
import { ThemeProvider } from "./assets/theme/ThemeProvider";
import { SnackbarProvider } from "./assets/vfx/snackbar/vfxSnackbarContext";
import { AuthProvider } from "./auth/authProvider";
import { CommunityProvider } from "./context/communityContext";
import { IdleTimerGate } from "./auth/idleTimerGate";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

const App = () => {
    const routes = useRoutes(AppRoutes);
    const navigate = useNavigate();
    const [hasNewNotification, toggleNewNotification] = useState(false);

    const setNewNotification = (hasNewNotifcation: boolean) => {
        toggleNewNotification(hasNewNotifcation);
    };

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <SnackbarProvider>
                    <AuthProvider>
                        <IdleTimerGate />
                        <CommunityProvider>
                            <Layout
                                environmentSettings={EnvironmentSettings()}
                                hasNewNotification={hasNewNotification}
                                setNewNotification={setNewNotification}
                                onLogin={() => onLogin(navigate)}
                                onLogout={() => onLogout(navigate)}
                            >
                                {routes}
                            </Layout>
                        </CommunityProvider>
                    </AuthProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </QueryClientProvider>
    );
};

export default App;